import { ScaleValueResponse } from './types';

export const SCALE_VALUE_RESPONSE = new Map<number, ScaleValueResponse>([
  [-1, -1],
  [1, 1],
  [2, 2],
  [3, 3],
  [4, 4],
  [5, 5],
]);

// Media queries aren't yet exposed as tokens so we’re replicating them within
// components for now and marking their usage with their equivalent Sass mixin
// names (in this case `ca-media-mobile`).
export const MEDIA_QUERIES = {
  mobile: '(max-width: 767px)',
};

export const OTHER_OPTION_ID = 'other_option';
